<template>
  <img :src="imageSrc" :srcset="retinaImageSrc" :alt="alt" />
</template>

<script>
import isAbsoluteUrl from "@/utils/isAbsoluteUrl";

export default {
  props: {
    src: {
      type: String,
      required: true
    },
    retinaSrc: {
      type: String,
      required: false
    },
    alt: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_URL
        ? process.env.VUE_APP_BASE_URL
        : process.env.BASE_URL
    };
  },
  computed: {
    imageSrc() {
      return isAbsoluteUrl(this.src) ? this.src : this.publicPath + this.src;
    },
    retinaImageSrc() {
      if (this.retinaSrc) {
        return (
          (isAbsoluteUrl(this.retinaSrc)
            ? this.retinaSrc
            : this.publicPath + this.retinaSrc) + " 2x"
        );
      } else {
        return null;
      }
    }
  },
  methods: {
    isAbsoluteUrl: url => isAbsoluteUrl(url)
  }
};
</script>
